import './basePanel.css';
import BasePanelHorse from "./horse/basePanelHorse";
import BasePanelInventory from './inventory/inventory';
import BasePanelLocation from "./location/basePanelLocation";

export default function BasePanel() {

  return (
    <div className="basePanel">
      <div className="basePanel-generic">
        character?
      </div>
      <BasePanelInventory/>
      <BasePanelLocation/>
      <BasePanelHorse/>
    </div>
  );
}